// John Eldhose 20180523
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Grid, IconButton, Typography } from '@material-ui/core';
import { Clear, Done } from '@material-ui/icons';
import RemoveFromCart from '../../actions/RemoveFromCart';
import ResetCart from '../../actions/ResetCart';
import ProfileAddress from '../lib/ProfileAddress';
import Checkout from '../lib/Checkout';

class App extends Component {

  state = {
    checkout: [],
    subtotal: 0,
    profile: null,
    address: null,
    baddress: null
  }
  componentWillMount() {
    this.setState({ subtotal: this.subtotal() });
  }
  subtotal = () => {
    const keys = Object.keys(this.props.ShoppingCart);
    var subtotal = 0;
    for(var i = 0; i < keys.length; i++)
      subtotal += this.props.ShoppingCart[keys[i]].maintenance;
    return subtotal;
  }
  deleteItem = (item) => {
    this.props.RemoveFromCart(item);
    this.setState({ subtotal: this.subtotal() });
  }
  handleCheckout = () => {
    const checkout = [], keys = Object.keys(this.props.ShoppingCart);
    for(var i = 0; i < keys.length; i++)
      checkout.push ({
        plan: 'Renew/Upgrade',
        serial: keys[i],
        name: this.props.ShoppingCart[keys[i]].PRODUCTNAME,
        description: 'Serial: ' + keys[i],
        quantity: 1,
        price: this.props.ShoppingCart[keys[i]].maintenance,
        taxCode: 'DC010500'
      });
    this.setState({ checkout: checkout });
  }

  render() {
    if(this.state.checkout.length > 0 && this.state.address !== null )
      return (
        <Checkout
          checkout={this.state.checkout}
          profile={this.state.profile}
          address={this.state.address}
          baddress={this.state.baddress}
          completed={() => this.props.ResetCart()}
        />
      );
    else if(this.state.checkout.length > 0 && this.state.address === null )
      return (
        <ProfileAddress
          Back={() => this.setState({ checkout: [], address: null })}
          Continue={(p, a, b) => this.setState({ profile: p, address: a, baddress: b })}
        />
      );
    else
      return (
        <div>
          <Typography variant='display1'>
            <center><font color='#385687'>Shopping Cart</font></center>
          </Typography>
          <p />
          <Grid container>
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8} className='ShoppingCart'>
              <table width='100%' className='ShoppingCartRow'>
                <tbody>
                  {Object.keys(this.props.ShoppingCart).map((key) => {
                    return (
                      <tr key={key} className='ShoppingCartRow'>
                        <td>
                          <Typography variant='body2'>
                            <b>
                              {this.props.ShoppingCart[key].PRODUCTNAME}
                            </b>
                          </Typography>
                          <Typography variant='body1'>
                            Serial: {key}
                          </Typography>
                          <Typography variant='body1'>
                            Modules: {this.props.ShoppingCart[key].mod}
                          </Typography>
                        </td>
                        <td align='right'>
                          <Typography variant='body1'>
                            {this.props.ShoppingCart[key].maintenance.toLocaleString('en-US', {
                              style: 'currency',
                              currency: 'USD',
                            })}
                          </Typography>
                        </td>
                        <td>
                          <IconButton
                            color="secondary"
                            onClick={() => this.deleteItem(key)}
                          >
                            <Clear style={{ fontSize: '15px' }}/>
                          </IconButton>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <div className='ShoppingCartTotal'>
                <table width='100%'>
                  <tbody>
                    <tr>
                      <td>
                        <Typography variant='body1'>Subtotal</Typography>
                      </td>
                      <td align='right'>
                        <Typography variant='body1'>
                          {this.subtotal().toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                          })}
                        </Typography>
                      </td>
                    </tr>
                    <tr><td colSpan='2'>&nbsp;</td></tr>
                    <tr>
                      <td colSpan='2' align='center'>
                        <Button
                          variant='raised'
                          color='primary'
                          size='large'
                          disabled={(
                            Object.keys(this.props.ShoppingCart).length < 1 ||
                            this.state.subtotal < 1 ||
                            this.state.checkout > 0
                          )}
                          onClick={this.handleCheckout}
                        >
                          <Done /> &nbsp; Checkout
                        </Button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <Typography variant='caption'>
                  <font size='1' style={{ fontStyle: 'italic' }}>
                    All pricing shown in United States Dollar (USD)
                  </font>
                </Typography>
              </div>
            </Grid>
          </Grid>
        </div>
      );
  }
}

const mapStateToProps = (state) => {
  return {ShoppingCart: state.ShoppingCart};
}

const mapDispatchToProps = (dispatch) => ({
  RemoveFromCart: (item) => dispatch(RemoveFromCart(item)),
  ResetCart: () => dispatch(ResetCart())
});

const ShoppingCart = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

export default ShoppingCart;



// WEBPACK FOOTER //
// ./src/components/home/ShoppingCart.js